module.exports = __webpack_public_path__ + "assets/8b3ba7faac8aa9595487c058855655af.png";